import { State } from '@/store/store'

export interface IPermission {
  column: Array<{
    text: string
    value: string
    type?: string
    options?: {
      orderable?: boolean
      lengthLimit?: number
      filter?: boolean
      operation: string[],
    },
  }>
  defaultFilter: object
  itemCount: number
  page: number
  pageCount: number
  result: Array<{
    _id?: string;
    name?: string;
  }>
}


export class PermissionState {
  public list: IPermission
  constructor() {
    this.list = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
  }
}

export default PermissionState
